import { BaseEdge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from '@xyflow/react';
import { X } from 'lucide-react';

export interface DadosAresta extends Record<string, unknown> {
  aoExcluir?: (arestaId: string) => void;
}

/**
 * Conexão entre dois nós. Mostra o rótulo da saída (a opção do menu, "sim/não", "ok/erro")
 * e um botão de excluir que aparece ao passar o mouse ou quando a conexão está selecionada —
 * apagar uma ligação não pode depender de descobrir um atalho de teclado.
 */
export function ArestaFluxo({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  label,
  selected,
  data,
}: EdgeProps & { data?: DadosAresta }) {
  const [caminho, meioX, meioY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={caminho}
        style={{
          stroke: selected ? '#1d5af0' : '#94a3b8',
          strokeWidth: selected ? 2.5 : 1.5,
        }}
        // Faixa invisível larga: dá para clicar na conexão sem mira de precisão.
        interactionWidth={24}
      />
      <EdgeLabelRenderer>
        <div
          className="group nodrag nopan pointer-events-auto absolute flex items-center gap-1"
          style={{ transform: `translate(-50%, -50%) translate(${meioX}px, ${meioY}px)` }}
        >
          {label && (
            <span className="rounded-full border border-neutral-300 bg-white px-1.5 py-0.5 text-[10px] text-neutral-600 shadow-sm dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-300">
              {label}
            </span>
          )}
          <button
            type="button"
            aria-label="Excluir conexão"
            title="Excluir conexão"
            onClick={(e) => {
              e.stopPropagation();
              data?.aoExcluir?.(id);
            }}
            className={`flex size-5 items-center justify-center rounded-full border bg-white text-neutral-500 shadow-sm transition hover:border-red-400 hover:bg-red-50 hover:text-red-600 dark:bg-neutral-800 ${
              selected
                ? 'border-marca-400 opacity-100'
                : 'border-neutral-300 opacity-0 group-hover:opacity-100 dark:border-neutral-600'
            }`}
          >
            <X size={12} />
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
